import { Route } from '@angular/router';

export const routeStartingPoint = (children: Array<Route>): Route => {
    return {
        children,
    };
};
